import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { useUser } from 'providers/UserProvider';

import LINKS from 'constants/links';

export const withAuth = (PageComponent) => {
  const WithAuthWrapper = (props) => {
    const router = useRouter();
    const [isLoading, setLoading] = useState(true);
    const { isLoggedIn, loadingLoggedInUser } = useUser();

    useEffect(() => {
      if (loadingLoggedInUser) {
        return;
      }

      if (!isLoggedIn) {
        router.replace(LINKS.HOME);
      }

      setLoading(false);
    }, [loadingLoggedInUser]);

    return <PageComponent {...props} isLoading={isLoading} />;
  };

  if (process.env.NODE_ENV !== 'production') {
    const name = PageComponent.displayName;

    WithAuthWrapper.displayName = `withAuth(${name})`;
  }

  return WithAuthWrapper;
};
